import React, { useEffect } from 'react';
import { InstallationHero } from '../components/installation/InstallationHero';
import { InstallationStepsSection } from '../components/installation/InstallationStepsSection';
import { SurfaceTypesSection } from '../components/installation/SurfaceTypesSection';
import { DisruptionSection } from '../components/installation/DisruptionSection';
import { QualityCheckpointsSection } from '../components/installation/QualityCheckpointsSection';
import { HomeownerDecisionsSection } from '../components/installation/HomeownerDecisionsSection';
import { TimelineSection } from '../components/installation/TimelineSection';
import { InstallationCTA } from '../components/installation/InstallationCTA';
export function InstallationPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-background font-sans antialiased" data-id="element-1271">
      <main data-id="element-1272">
        <InstallationHero data-id="element-1273" />
        <InstallationStepsSection data-id="element-1274" />
        <SurfaceTypesSection data-id="element-1275" />
        <DisruptionSection data-id="element-1276" />
        <QualityCheckpointsSection data-id="element-1277" />
        <HomeownerDecisionsSection data-id="element-1278" />
        <TimelineSection data-id="element-1279" />
        <InstallationCTA data-id="element-1280" />
      </main>
    </div>;
}